import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { isConnectorConnected, resolveConnectorId, startConnectorAuthorization, } from '../services/oauthConnect';
import { openOAuthPopup, waitForOAuthCompletion } from '../utils/oauth-helpers';
export const useOAuthMutations = () => {
    const { user } = useAuth();
    const [connectionStates, setConnectionStates] = useState({});
    /**
     * Connects the user's personal account through the platform's V2 connector flow. The
     * platform's callback stores the credential; the `office-` name prefix is what
     * `useOAuthIntegrations` reads to show the integration as connected.
     */
    const connectToProvider = async (provider, credentialType, integrationId, boundConnectorId) => {
        try {
            setConnectionStates((prev) => ({ ...prev, [integrationId]: true }));
            const accessToken = user?.access_token;
            if (!accessToken) {
                throw new Error('User not authenticated');
            }
            const connectorId = await resolveConnectorId(credentialType, boundConnectorId, accessToken);
            const redirectUrl = await startConnectorAuthorization(connectorId, `office-${provider.toLowerCase()}-${Date.now()}`, accessToken);
            const popup = openOAuthPopup(redirectUrl);
            await waitForOAuthCompletion(popup, () => isConnectorConnected(connectorId, accessToken));
        }
        catch (error) {
            console.error(`Failed to connect to ${provider}:`, error);
            throw error;
        }
        finally {
            setConnectionStates((prev) => ({ ...prev, [integrationId]: false }));
        }
    };
    return {
        connectToProvider,
        connectionStates,
    };
};
